// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#upload_dialog { width: 400px }
#cdk-overlay-0 { position: absolute; bottom: 0; right: 0;}
input { min-width: 300px; width: 100% }
.error { font-size: 13px; color: #d32f2f }
mat-progress-spinner { width: 50px; height: 50px }
.main {
   display: flex;
   background-color: #2AB4C0;
   color: white;
}
.main div { flex: 1; }
#icon_arrow { text-align: right; cursor: pointer; margin: 10px; }
.file-icon img {
   display: block;
   width: 28px;
   height: 28px;
   object-fit: contain;
}
.file-icon img.cover {
   object-fit: cover;
}
h2.mat-dialog-title {
   margin: 5px;
}
i {
   font-size: 14px;
}
.mat-dialog-content {
   margin: 0;
   padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/upload-files/upload-files.component.css"],"names":[],"mappings":"AAAA,iBAAiB,aAAa;AAC9B,iBAAiB,kBAAkB,EAAE,SAAS,EAAE,QAAQ,CAAC;AACzD,QAAQ,gBAAgB,EAAE,YAAY;AACtC,SAAS,eAAe,EAAE,eAAe;AACzC,uBAAuB,WAAW,EAAE,aAAa;AACjD;GAEG,aAAa;GACb,yBAAyB;GACzB,YAAY;AACf;AACA,YAA0C,OAAO,EAAE;AACnD,cAAc,iBAAiB,EAAE,eAAe,EAAE,YAAY,EAAE;AAChE;GACG,cAAc;GACd,WAAW;GACX,YAAY;GACZ,mBAAmB;AACtB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,WAAW;AACd;AACA;GACG,eAAe;AAClB;AACA;GACG,SAAS;GACT,UAAU;AACb","sourcesContent":["#upload_dialog { width: 400px }\n#cdk-overlay-0 { position: absolute; bottom: 0; right: 0;}\ninput { min-width: 300px; width: 100% }\n.error { font-size: 13px; color: #d32f2f }\nmat-progress-spinner { width: 50px; height: 50px }\n.main {\n   display: -webkit-flex;\n   display: flex;\n   background-color: #2AB4C0;\n   color: white;\n}\n.main div { -webkit-flex: 1; -ms-flex: 1; flex: 1; }\n#icon_arrow { text-align: right; cursor: pointer; margin: 10px; }\n.file-icon img {\n   display: block;\n   width: 28px;\n   height: 28px;\n   object-fit: contain;\n}\n.file-icon img.cover {\n   object-fit: cover;\n}\nh2.mat-dialog-title {\n   margin: 5px;\n}\ni {\n   font-size: 14px;\n}\n.mat-dialog-content {\n   margin: 0;\n   padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
